import React from "react";
import QuoteStepBase, { getDriverStepMapDispatch, mapDriverStepProps } from '../components/QuoteStepBase'
import ButtonContinue from "../components/ButtonContinue";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import Question from '../components/Question'
import { Button } from 'react-bootstrap'
import QuoteStep from "./QuoteStepLayout";
import { ValidatableForm } from "../components/ValidatableForm";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import { PATHS, QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";
import Utilities from "../classes/Utilities";
import { IAppState } from "../state/interfaces";
import ReactLoading from 'react-loading';

interface IState extends IQuoteStepState {
    licenseSuspendedRevokedFiveYears: string,
    sr22: string,
    accidentsViolations: string,
    updatingStore: boolean,
    addDriverClick: boolean,
    continueClick: boolean;
}

interface IDrivingHistoryProps extends IDriverStepProps {
    driversCount: number
}

class DrivingHistory extends QuoteStepBase<IDrivingHistoryProps, IState> {
    constructor(props: IDrivingHistoryProps) {
        super(props);
        this.next = this.next.bind(this);

        this.state = {
            licenseSuspendedRevokedFiveYears : "",
            sr22 : "",
            accidentsViolations: "",
            updatingStore: false,
            addDriverClick: false,
            continueClick: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();        
    }

    subscribeToValidation() {
        validationUtils.subscribeToValidationFailure(QUOTE_STEPS.DRIVING_HISTORY,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, continueClick: false, addDriverClick: false, errors: validationData });
            });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const driver = nextProps.driver;
            nextProps.meta.propsSource = "";

            if (null === driver) return prevState;

            return {
                ...prevState,
                licenseSuspendedRevokedFiveYears: !!driver.licenseSuspendedRevokedFiveYears ? driver.licenseSuspendedRevokedFiveYears : QUOTE_QUESTIONS.YES_NO.NO,
                sr22: !!driver.sr22 ? driver.sr22 : QUOTE_QUESTIONS.YES_NO.NO,
                accidentsViolations: !!driver.accidentsViolations ? driver.accidentsViolations : QUOTE_QUESTIONS.YES_NO.NO
            };
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true, continueClick: true, addDriverClick: false }, () => {
            const updatedDriver = {
                ...this.props.driver,
                licenseSuspendedRevokedFiveYears: this.state.licenseSuspendedRevokedFiveYears,
                sr22: this.state.sr22,
                accidentsViolations: this.state.accidentsViolations
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(PATHS.NEW_POLICY /*Utilities.formatUrl(PATHS.CURRENT_INSURANCE, (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""))*/),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    callbackFunctionLicense = (childData:string) => {
        switch (childData) {
            case "Yes":
                this.setState({visible: true});
                break;
            case "No":
                this.setState({visible: false});
                break;
        }
    };

    onAddDriverClick() {
        this.setState({ updatingStore: true, continueClick: false, addDriverClick: true }, () => {
            const updatedDriver = {
                ...this.props.driver,
                licenseSuspendedRevokedFiveYears: this.state.licenseSuspendedRevokedFiveYears,
                sr22: this.state.sr22,
                accidentsViolations: this.state.accidentsViolations
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(PATHS.ABOUT_YOU, this.props.driversCount.toString())),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea"><h5>YOUR DRIVING HISTORY</h5></div>

                    {
                        //<Question
                        //    name="licenseSuspendedRevokedFiveYears"
                        //    selected={(v) => { this.setStateValue(v, "licenseSuspendedRevokedFiveYears") }}
                        //    selectedValue={this.state.licenseSuspendedRevokedFiveYears}
                        //    error={validationUtils.getValidationErrorFor(this.state.errors, "licenseSuspendedRevokedFiveYears")}
                        //    items={[
                        //        QUOTE_QUESTIONS.YES_NO.YES,
                        //        QUOTE_QUESTIONS.YES_NO.NO
                        //    ]}
                        //    lable="Has your license been suspended or revoked in the last 5 years?" />
                    }

                    <Question
                        name="sr22"
                        selected={(v) => { this.setStateValue(v, "sr22") }}
                        selectedValue={this.state.sr22}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "sr22")}
                        items={[
                            QUOTE_QUESTIONS.YES_NO.YES,
                            QUOTE_QUESTIONS.YES_NO.NO
                        ]}
                        lable="Are you required to have an SR-22 or other Financial Responsibility document?" />

                    {
                        //<Question
                        //    name="accidentsViolations"
                        //    selected={(v) => { this.setStateValue(v, "accidentsViolations") }}
                        //    selectedValue={this.state.accidentsViolations}
                        //    error={validationUtils.getValidationErrorFor(this.state.errors, "accidentsViolations")}
                        //    items={[
                        //        QUOTE_QUESTIONS.YES_NO.YES,
                        //        QUOTE_QUESTIONS.YES_NO.NO
                        //    ]}
                        //    lable="Have you had any accidents, moving violations, or claims in the last 5 years?" />
                    }

                    <div className="btnContainer">
                        <Button
                            className="btnAddDriver"
                            onClick={() => { this.onAddDriverClick() }}
                            disabled={this.state.updatingStore}>{this.state.updatingStore && this.state.addDriverClick ? <ReactLoading type={"spin"} className="continue-loading" color={"#389BFF"} height={'20px'} width={'20px'} /> : <i className="fas fa-plus"></i>} Add another driver
                                    </Button>

                        <div className="orText"><p>or</p></div>

                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore && this.state.continueClick}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var props = mapDriverStepProps(state, ownProps);
    props["driversCount"] = state.drivers.length;

    return props;
}

export default connect(mapProps, getDriverStepMapDispatch(QUOTE_STEPS.DRIVING_HISTORY))(DrivingHistory);
